import {Button, DatePicker, Divider, Form, Input, Modal, Radio, TimePicker} from "antd";
import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import {ClockCircleOutlined, FormOutlined} from "@ant-design/icons";

export default (props) => {
    const [open, setOpen] = useState(false)
    const [date, setDate] = useState(dayjs())
    const [layout, setLayout] = useState('notes')
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()

    const handleSave = (e) => {
        if(props.onSave) {
            setLoading(true)
            props.onSave({
                type: layout,

            })
        }
    }

    useEffect(() => {
        setOpen(props.open)
        if(props.date)
            setDate(dayjs(props.date))
        return () => {
            if(loading)
                setLoading(false)
        }
    }, [props.open])

    function notesLayout() {
        return (
            <Form
                form={form}
                layout={'vertical'}
            >
                <Form.Item name='title'>
                    <Input
                         rules={[
                        {
                          required: true,
                          message: 'Missing title'
                        }
                      ]}
                        placeholder='Add title'
                    />
                </Form.Item>

                <Form.Item name='notes'>
                    <Input.TextArea
                        rows={10}
                        placeholder='Add notes'
                    />
                </Form.Item>
            </Form>
        )
    }

    function reminderLayout() {
        const onTimeChange = (time, timeString) => {
            console.log(time, timeString)
        }
        return (
            <Form
                form={form}
                layout={'vertical'}
            >
                <Form.Item name='title'>
                    <Input
                        rules={[
                        {
                          required: true,
                          message: 'Missing title'
                        }
                      ]}
                        placeholder='Add title'
                    />
                </Form.Item>

                <Form.Item name='title'>
                    <div style={{display: 'flex', gap: 6}}>
                        <DatePicker defaultValue={date}/>
                        <TimePicker onChange={onTimeChange} defaultOpenValue={dayjs(date, 'HH:mm:ss')}/>
                    </div>
                </Form.Item>
            </Form>
        )
    }

    return (
        <Modal title={props.title} open={open} onCancel={props.onClose} footer={[
            <Button
                key="Save"
                type="primary"
                loading={loading}
                onClick={handleSave}
            >
                Save
            </Button>,
        ]}>
            <div style={{display: 'flex', gap: 2, flexDirection: 'column'}}>
                <Radio.Group value={layout} onChange={(e) => setLayout(e.target.value)}>
                    <Radio.Button value="notes"><FormOutlined /> Notes</Radio.Button>
                    <Radio.Button value="reminder"><ClockCircleOutlined /> Reminder</Radio.Button>
                </Radio.Group>
                <div style={{marginTop: 12}}>
                    {layout === 'notes' && notesLayout()}
                    {layout === 'reminder' && reminderLayout()}
                </div>
            </div>
        </Modal>
    )
}